module.exports = __webpack_public_path__ + "media/PAG63-11.be98f8f1.mp3";